import PropTypes from 'prop-types'

import placeholderFactory from './factory'

export default placeholderFactory('AcpFooter', {
  children: PropTypes.node.isRequired,
})
